const flattenAmountBifurcation = (data = []) => {
  let returnValue = [];
  for (let i = 0; i < data.length; i += 1) {
    if (Array.isArray(data[i])) {
      returnValue = returnValue.concat(flattenAmountBifurcation(data[i]));
    } else {
      returnValue.push(data[i]);
      if (Array.isArray(data[i].content)) {
        returnValue = returnValue.concat(flattenAmountBifurcation(data[i].content));
      }
    }
  }
  return returnValue;
};
export default flattenAmountBifurcation;
